import React from "react";

// Simplified stylized rendition of the Escudo Nacional del Perú.
// Vicuña (top-left, tan), Cinchona tree (top-right, green),
// Cornucopia (bottom, gold coins).
export default function EscudoNacional({ size = 44, className = "", title }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 110"
      width={size}
      height={size * 1.1}
      className={className}
      role="img"
      aria-label={title || "Escudo Nacional del Perú"}
    >
      <title>{title || "Escudo Nacional del Perú"}</title>
      {/* Outer shield */}
      <path
        d="M50 4 C 20 4 8 8 8 8 L 8 55 C 8 82 30 100 50 106 C 70 100 92 82 92 55 L 92 8 C 92 8 80 4 50 4 Z"
        fill="#ffffff"
        stroke="#0b2545"
        strokeWidth="3"
      />
      {/* Quartered divisions */}
      <path d="M50 8 V52" stroke="#0b2545" strokeWidth="1.5" />
      <path d="M10 40 H50" stroke="#0b2545" strokeWidth="1.5" />
      <path d="M50 40 H90" stroke="#0b2545" strokeWidth="1.5" />
      <path d="M12 52 H88" stroke="#0b2545" strokeWidth="1.5" />

      {/* Top-left: sky-blue with Vicuña silhouette */}
      <path
        d="M11 10 L50 10 L50 40 L11 40 Z"
        fill="#a4c8ec"
      />
      {/* Vicuña simple silhouette */}
      <g fill="#a06a3f">
        <path d="M18 30 c1-4 4-6 7-6 c2 0 3 -3 5 -3 c2 0 3 2 3 3 c0 2 2 3 2 5 c0 4 -3 6 -6 6 l-11 0 z" />
        <rect x="20" y="34" width="1.5" height="4" />
        <rect x="26" y="34" width="1.5" height="4" />
        <path d="M31 22 l1 -3 l1 3 z" />
      </g>

      {/* Top-right: white with Cinchona tree (Quina) */}
      <path d="M50 10 L89 10 L89 40 L50 40 Z" fill="#f5f7fa" />
      <g>
        <rect x="66" y="30" width="3" height="8" fill="#5b3a1f" />
        <circle cx="67.5" cy="24" r="7" fill="#0f8a5f" />
        <circle cx="63" cy="21" r="4" fill="#12a26e" />
        <circle cx="72" cy="22" r="4" fill="#12a26e" />
      </g>

      {/* Bottom: red with cornucopia and gold coins */}
      <path
        d="M10 40 L90 40 L90 55 C 90 80 70 96 50 100 C 30 96 10 80 10 55 Z"
        fill="#d0111b"
      />
      {/* Cornucopia horn */}
      <path
        d="M28 70 C 34 60 46 58 58 62 C 66 65 72 72 68 82 C 60 78 48 76 40 80 C 34 82 30 78 28 70 Z"
        fill="#e6b45a"
        stroke="#8a5a1a"
        strokeWidth="1.2"
      />
      {/* Gold coins spilling */}
      <g fill="#f7d774" stroke="#8a5a1a" strokeWidth="0.7">
        <circle cx="60" cy="82" r="3" />
        <circle cx="66" cy="86" r="2.6" />
        <circle cx="54" cy="87" r="2.4" />
        <circle cx="48" cy="90" r="2.2" />
        <circle cx="42" cy="87" r="2.2" />
      </g>
    </svg>
  );
}
